(function(){
function boot(){
  var S=window.GBS;
  [].forEach.call(document.querySelectorAll('[data-gbm]'),function(root){
    if(root.dataset.ready) return;
    if(!S||!S.cat||!S.cat().length){ return; }
    root.dataset.ready='1';
    var max=+root.dataset.max||6, sel=[], cat=S.cat(), C=326.73;
    var q=function(s){return root.querySelector(s)};
    var grid=q('[data-grid]'),tray=q('[data-tray]'),thumbs=q('[data-thumbs]'),tot=q('[data-tot]'),was=q('[data-was]'),off=q('[data-off]'),btn=q('[data-btn]'),wab=q('[data-wa-btn]'),hint=q('[data-hint]'),arc=q('[data-arc]'),ring=q('[data-ring]'),rm=q('[data-ring-main]'),dots=q('[data-dots]'),prev=q('[data-prev]'),next=q('[data-next]'),steps=[].slice.call(root.querySelectorAll('.gbm__step'));
    q('[data-p2]').textContent=S.PCT[2]+'% off'; q('[data-p3]').textContent=S.PCT[3]+'% off';
    grid.innerHTML=cat.map(function(p){
      var disc=(+p.w>+p.p)?'<s>'+S.money(p.w)+'</s>':'';
      return '<button type="button" class="gbm__card" data-h="'+S.esc(p.h)+'" aria-pressed="false" aria-label="'+S.esc(p.n)+', '+S.money(p.p)+'"><span class="gbm__tag">'+S.esc(p.k)+'</span><span class="gbm__img"><img src="'+S.esc(p.i)+'" alt="" loading="lazy" width="400" height="400"></span><span class="gbm__name">'+S.esc(p.n)+'</span><span class="gbm__row"><span class="gbm__price">'+S.money(p.p)+disc+'</span><span class="gbm__add" aria-hidden="true">+</span></span></button>';
    }).join('');
    dots.innerHTML=cat.map(function(){return '<i></i>'}).join('');
    var lastPct=-1;
    function toggle(h){ var i=sel.indexOf(h); if(i>-1){ sel.splice(i,1); } else { if(sel.length>=max) return; sel.push(h); } run(); }
    function run(){
      [].forEach.call(grid.children,function(c){ c.setAttribute('aria-pressed',sel.indexOf(c.dataset.h)>-1?'true':'false'); });
      var list=sel.map(S.by).filter(Boolean), n=list.length, t=S.sum(list);
      steps.forEach(function(s){ var k=+s.dataset.st; s.classList.toggle('is-on',k===1?n===1:(k===2?n===2:n>=3)); });
      arc.style.strokeDashoffset=C*(1-Math.min(1,n/3));
      rm.textContent=t.pct+'%';
      if(t.pct!==lastPct&&lastPct!==-1&&t.pct>0){ ring.classList.remove('is-pop'); void ring.offsetWidth; ring.classList.add('is-pop'); }
      lastPct=t.pct;
      hint.textContent=n===0?'Tap a product to start your glow set.':(n===1?'Add 1 more to save '+S.PCT[2]+'%.':(n===2?'Add 1 more to save '+S.PCT[3]+'% instead.':'Best saving unlocked: '+S.PCT[3]+'% off your whole set.'));
      thumbs.innerHTML=n?list.map(function(p){return '<img src="'+S.esc(p.i)+'" alt="'+S.esc(p.n)+'" title="'+S.esc(p.n)+'">'}).join(''):'<span class="gbm__empty">Tap products to build your set</span>';
      tot.textContent=S.money(t.total); tray.classList.toggle('has-off',t.pct>0);
      if(t.pct>0){ was.textContent=S.money(t.sub); off.textContent='Save '+t.pct+'%'; }
      btn.classList.toggle('is-off',n<1); btn.href=n?S.cartLink(list):'#';
      if(wab){ wab.classList.toggle('is-off',n<1); wab.href=n?S.waLink(list):'#'; }
    }
    function pos(){
      var w=grid.scrollWidth-grid.clientWidth, x=grid.scrollLeft;
      prev.disabled=x<8; next.disabled=x>w-8;
      var f=grid.children[0]; if(!f) return; var step=f.offsetWidth+12, i=Math.min(cat.length-1,Math.round(x/step));
      [].forEach.call(dots.children,function(d,k){ d.classList.toggle('is-on',k===i); });
    }
    function go(d){ var f=grid.children[0]; grid.scrollBy({left:d*(f?(f.offsetWidth+12)*2:300),behavior:'smooth'}); }
    prev.addEventListener('click',function(){go(-1)}); next.addEventListener('click',function(){go(1)});
    grid.addEventListener('scroll',function(){ window.requestAnimationFrame(pos) },{passive:true});
    window.addEventListener('resize',pos);
    grid.addEventListener('click',function(e){ var c=e.target.closest('.gbm__card'); if(c) toggle(c.dataset.h); });
    var seed=window.GBPAGE; if(seed&&S.by(seed)) sel.push(seed);
    run(); pos();
  });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
window.addEventListener('load',boot);
})();